export enum GenericErrorCodes {
  "FIELD_REQUIRED" = "FIELD_REQUIRED",
  "INVALID_STRING" = "INVALID_STRING",
  "INVALID_NUMBER" = "INVALID_NUMBER",
  "MINIMUM_CHARACTERS_NOT_MET" = "MINIMUM_CHARACTERS_NOT_MET",
}
